<template>
  <div>
    <FilterCard :applied-filter-count="appliedFilterCount">
      <b-row>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Rider"
            label-for="rider-name"
          >
            <v-select
              id="rider-name"
              v-model="filters['staff_id']"
              :options="riders"
              :reduce="option => option.id"
              label="first_name"
              placeholder="Select Rider"
            >
              <!-- @change="filteredId()" -->
              <template v-slot:option="option">
                {{ option.reference_id }} | {{ option.first_name }} {{ option.last_name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Ref No"
            label-for="v-ref-no"
          >
            <b-form-input
              id="v-ref-no"
              v-model="filters['ref_no']"
              placeholder="Search"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Status"
            label-for="deposit_status"
          >
            <v-select
              v-model="filters['status']"
              :options="statusOptions"
              :reduce="option => option.key"
              label="name"
              placeholder="Select Status"
            >
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Created At"
            label-for="created-at"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['created_at']"
                :opens="'left'"
                @update="updateDateRange('created_at', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Apply and Clear Filters -->
      <b-row class="mt-1">
        <b-col>
          <filter-buttons
            :filter-data="filters"
            :apply-filters="applyFilters"
            :clear-filters="clearFilters"
          />
        </b-col>
      </b-row>
    </FilterCard>
    <div>
      <b-card
        no-body
      >
        <div
          class="m-2"
        >
          <b-row class="d-sm-flex align-items-start">
            <b-col
              md="12"
              lg="8"
              class="d-block d-sm-flex flex-wrap justify-content-start align-items-center mb-1 mb-md-0"
            >
              <b-button
                v-can="'rider-finance-paid'"
                :disabled="depositSelected.length === 0"
                class="mr-1 add-margin-bottom"
                variant="success"
                @click="onClickMakePayment()"
              >
                Make Payment
              </b-button>
              <b-button
                v-can="'rider-finance-approve'"
                :disabled="depositSelected.length === 0"
                class="mr-1 add-margin-bottom"
                variant="info"
                @click="onClickApprove()"
              >
                Approve
              </b-button>
              <b-button
                v-can="'rider-finance-reject'"
                :disabled="depositSelected.length === 0"
                class="mr-1 add-margin-bottom"
                variant="danger"
                @click="onClickReject()"
              >
                Reject
              </b-button>
              <b-button
                v-can="'rider-finance-create'"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                class="mr-1 custom-button-color add-margin-bottom"
                @click="onClickNewDeposit()"
              >
                <feather-icon icon="PlusIcon" />
                Add New Deposit
              </b-button>
            </b-col>
            <b-col
              class="d-flex justify-content-end align-items-center mb-1 mb-md-0"
            >
              <ReportTableButtons
                :items="items"
                :json_fieldz="json_fields"
                :name="`RiderDeposits - Page ${page}.xls`"
                :bulkname="`RiderDeposits.xls`"
                :fetch="fetchDataForRiderNoPagination"
                @refresh="onClickRefresh"
              />
            </b-col>
          </b-row>
          <b-row>
            <div class="font-weight-bolder text-muted ml-1 mt-1">
              {{ `${depositSelected.length} record${depositSelected.length === 1 ? '':'s'}` }} selected
            </div>
          </b-row>
        </div>

        <!-- table -->
        <b-overlay
          id="overlay-background"
          blur="10px"
          opacity="0.30"
          rounded="sm"
          variant="light"
        >
          <b-table
            :per-page="perPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            hover
            responsive
            striped
            show-empty
            sticky-header="100vh"
            class="hide-vertical-scroll"
            @sort-changed="sortChanged"
          >
            <template #empty>
              <TableDataFetching
                :rows="items"
                :data-loading="dataLoading"
              />
            </template>
            <template #head()="{ field }">
              <div
                class="sortable-header"
              >
                <span class="header-text">{{ field.label }}</span>
                <feather-icon
                  v-if="field.sortable"
                  :icon="sort === field.key
                    ? 'ArrowUpIcon'
                    : 'ArrowDownIcon'"
                  size="14"
                />
              </div>
            </template>
            <template #head(id)>
              <div class="d-flex align-items-start">
                <div>
                  <b-form-checkbox
                    id="selectAllCheckbox"
                    v-model="selectAllCheckbox"
                    name="selectAllCheckbox"
                    @change="onClickSelectAllCheckbox()"
                  />
                </div>
              </div>
            </template>
            <template #cell(id)="data">
              <div class="d-flex align-items-start">
                <div>
                  <div class="font-weight-bolder">
                    <b-form-checkbox
                      v-model="depositSelected"
                      :value="data.item.id"
                    />
                  </div>
                </div>
              </div>
            </template>
            <template #cell(ref_no)="data">
              <div class="d-flex align-items-center">
                <b-avatar
                  :text="avatarText(data.item.ref_no)"
                  size="32"
                  variant="light-primary"
                />
                <div class="ml-1">
                  <div
                    class="font-weight-bolder text-primary"
                    @click="onClickRef(data.item.id)"
                  >
                    {{ data.value }}
                  </div>
                  <div class="font-small-2">
                    {{ __dateTimeFormatter(data.item.created_at) }}
                  </div>
                </div>
              </div>
            </template>
            <template #cell(rider)="data">
              <div class="d-flex align-items-center">
                <div>
                  <div class="font-weight-bolder">
                    {{ data.item.rider ? data.item.rider.first_name : '---' }}
                  </div>
                  <div class="font-small-2">
                    {{ data.item.rider && data.item.rider.reference_id ? data.item.rider.reference_id : '' }}
                  </div>
                </div>
              </div>
            </template>
            <template #cell(depositable_amount)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(deposit_amount)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(expenses_total)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(deposited_amount)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(pending_deposited_amount)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(commission)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(deposited_date)="data">
              {{ __dateTimeFormatter(data.value) || '---' }}
            </template>
            <template #cell(approved_date)="data">
              {{ __dateTimeFormatter(data.value) || '---' }}
            </template>
            <template #cell(finance_current_status.key)="data">
              <finance-status-badge
                :status-key="data.value"
                :finance-status="statusOptions"
              />
              <div
                v-if="data.item.is_reversed_deposit"
                class="mt-1 d-flex justify-content-center"
              >
                <b-tooltip
                  :target="data.item.id.toString()"
                  triggers="hover"
                  variant="danger"
                >
                  Rejected Once
                </b-tooltip>
                <b-avatar
                  :id="data.item.id.toString()"
                  size="20"
                  style="background-color: #ffb5b5"
                >
                  <feather-icon
                    icon="ChevronsLeftIcon"
                    class="text-body align-middle"
                  />
                </b-avatar>
              </div>
            </template>
            <template #cell(action)="data">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                :class="items.length !== 1 ? 'dropdown-no-scroll':''"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="12"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  v-if="data.item.receipt_url"
                  :href="`${bucketUrl}${data.item.receipt_url}`"
                  target="_blank"
                >
                  <feather-icon icon="EyeIcon" />
                  View Payment Slip
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="data.item.is_reversed_deposit"
                  @click="onClickShowRejectionReasons(data.item.id)"
                >
                  <feather-icon icon="BookIcon" />
                  Rejection Reasons
                </b-dropdown-item>
                <b-dropdown-item
                  v-can="'rider-finance-show'"
                  :to="{ name: 'rider-deposit-orders', params: { id: data.item.id } }"
                >
                  <feather-icon icon="ToolIcon" />
                  View Orders
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="data.item.finance_current_status.key !== 'f_key_1'"
                  v-can="'rider-finance-show'"
                  @click="onClickPrint(data.item.id)"
                >
                  <feather-icon icon="PrinterIcon" />
                  Print Deposit Note
                </b-dropdown-item>
              </b-dropdown>
            </template>

          </b-table>
        </b-overlay>

        <div class="mx-2 mb-2">
          <b-row
            cols="12"
          >
            <b-col
              class="d-flex align-items-center justify-content-sm-start"
              md="3"
            >
              <label class="width-75">Per page</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="pageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block width-100"
              />
            </b-col>
            <!-- Pagination -->
            <b-col
              class="d-flex align-items-center justify-content-sm-end"
              md="9"
            >
              <span class="text-muted pagination-text  mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
              <b-pagination
                v-model="page"
                :total-rows="(meta.total)? meta.total : 0"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
    <make-deposite-action ref="make_deposit_action_modal" />
    <approve-action ref="approve_action_modal" />
    <reject-action ref="reject_action_modal" />
    <rejection-details ref="rejection_detail_modal" />
    <print-rider-deposit ref="print_deposit_modal" />
  </div>
</template>

<script>
import {
  BFormCheckbox,
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  VBModal,
  BAvatar,
  BOverlay,
  BDropdown,
  BDropdownItem,
  VBTooltip,
  BTooltip,
} from 'bootstrap-vue'
import FinanceStatusBadge from '@core/components/status/FinanceStatusBadge.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { bucketUrl } from '@/constants/config'
import { avatarText } from '@core/utils/filter'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import MakeDepositeAction from '@/components/FinanceModuleForms/ActionForms/MakeDepositeAction.vue'
import ApproveAction from '@/components/FinanceModuleForms/ActionForms/ApproveAction.vue'
import RejectAction from '@/components/FinanceModuleForms/ActionForms/RejectAction.vue'
import PrintRiderDeposit from '@/components/FinanceModuleForms/Print/PrintRiderDepositModal.vue'
import RejectionDetails from '@/components/FinanceModuleForms/InfoModals/RejectionDetailModal.vue'
import store from '@/store/index'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'

const FinanceRepository = RepositoryFactory.get('finance')
const RiderRepository = RepositoryFactory.get('rider')
const ResourceRepository = RepositoryFactory.get('resource')

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    MakeDepositeAction,
    ApproveAction,
    RejectAction,
    vSelect,
    BOverlay,
    AdvancedDateFilter,
    BTooltip,
    BAvatar,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BCol,
    BFormGroup,
    BPagination,
    BButton,
    BFormInput,
    BDropdown,
    BDropdownItem,
    FinanceStatusBadge,
    PrintRiderDeposit,
    RejectionDetails,
    FilterButtons,
    FilterCard,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  data() {
    return {
      bucketUrl,
      avatarText,
      depositSelected: [],
      filters: {
        created_at: {
          startDate: null,
          endDate: null,
        },
      },
      dataLoading: false,
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      meta: {},
      dir: false,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      riders: [],
      filterName: '',
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'id',
          sortable: false,
        },
        {
          key: 'ref_no',
          label: 'REF',
          thClass: 'text-center',
          sortable: true,
        },
        {
          key: 'rider',
          label: 'Rider',
          sortable: true,
        },
        {
          key: 'warehouse.name',
          label: 'Warehouse',
          sortable: true,
        },
        {
          key: 'depositable_amount',
          label: 'Collected COD',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'expenses_total',
          label: 'Expenses Total',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'deposited_amount',
          label: 'Deposited Amount',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'pending_deposited_amount',
          label: 'Pending Deposited Amount',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'commission',
          label: 'Commission',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'deposit_amount',
          label: 'Depositable Amount',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'deposited_date',
          label: 'Deposited Date',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'approved_date',
          label: 'Approved Date',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'finance_current_status.key',
          label: 'Status',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        { key: 'action', label: 'Action', sortable: false },
      ],
      json_fields: {
        REF: 'ref_no',
        'Deposit Date': {
          field: 'created_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        Rider: {
          field: 'rider.first_name',
          callback: value => `"${value}"`,
        },
        'Rider Employee Id': {
          callback: value => `"${value.rider !== null ? `${value.rider.reference_id}` : 'N/A'}"`,
        },
        Warehouse: {
          field: 'warehouse.name',
          callback: value => `"${value}"`,
        },
        'Depositable Amount': 'depositable_amount',
        'Expenses Total': 'expenses_total',
        Commission: 'commission',
        'Deposit Amount': 'deposit_amount',
        'Deposited Date': {
          field: 'deposited_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Approved Date': {
          field: 'approved_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        Status: 'finance_current_status.name',
      },
      items: [],
      statusOptions: [],
      selectAllCheckbox: false,
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchDataForRider()
      },
    },
    deep: true,
    page() {
      this.fetchDataForRider()
    },
    perPage() {
      this.fetchDataForRider()
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    this.setMonthFilter()
    this.fetchDataForRider()
    this.readDataforRider()
    this.statusOptions = JSON.parse(localStorage.getItem('finance_statuses'))
    this.updateFilterCount()
  },
  methods: {
    setMonthFilter() {
      const currentMonth = this.monthFilter()
      this.updateDateRange('created_at', currentMonth)
    },
    async readDataforRider() {
      try {
        this.riders = localStorage.getItem('all_rider_list') ? JSON.parse(localStorage.getItem('all_rider_list')) : (await RiderRepository.getAllRidersForDropdown()).data.data
        if (!localStorage.getItem('all_rider_list')) localStorage.setItem('all_rider_list', JSON.stringify(this.riders))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchDataForRider() {
      this.dataLoading = true
      this.items = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await FinanceRepository.getRiderFinanceDepositList(this.page, filterQuery, this.perPage, this.sort))
        const assignedWarehouses = await ResourceRepository.getAssignedWarehousesNoPagination()

        const assignedWarehouseNames = (assignedWarehouses?.data?.data ?? []).map(element => element?.name).filter(Boolean)
        const filteredItems = (data?.data ?? []).map(item => {
          const warehouseName = item?.deposited_warehouse?.name && assignedWarehouseNames.includes(item.deposited_warehouse.name)
            ? item.deposited_warehouse.name
            : 'N/A'

          return {
            ...item, // Retain other item properties
            warehouse: {
              ...item?.deposited_warehouse, // Preserve warehouse structure if it exists
              name: warehouseName, // Replace or set the name
            },
          }
        })
        this.items = filteredItems
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchDataForRiderNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await FinanceRepository.getRiderFinanceDepositListNoPagination(filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    handleChangePage(page) {
      this.page = page
      this.fetchDataForRider()
    },
    applyFilters() {
      this.fetchDataForRider()
      this.deselectAll()
      this.updateFilterCount()
    },
    clearFilters() {
      this.filters = {
        created_at: {
          startDate: null,
          endDate: null,
        },
      }
      this.$nextTick(() => {
        this.fetchDataForRider()
      })
      this.updateFilterCount()
    },
    selectAll() {
      this.depositSelected = this.items.map(n => n.id)
    },
    deselectAll() {
      this.depositSelected = []
    },
    onClickMakePayment() {
      this.$refs.make_deposit_action_modal.openModal(this.depositSelected, 'rider')
    },
    onClickApprove() {
      this.$refs.approve_action_modal.openModal(this.depositSelected, 'rider')
    },
    onClickReject() {
      this.$refs.reject_action_modal.openModal(this.depositSelected, 'rider')
    },
    onClickNewDeposit() {
      this.$router.push({ name: 'add-new-rider-deposit' })
    },
    onClickShowRejectionReasons(id) {
      this.$refs.rejection_detail_modal.openModal(id, 'rider')
    },
    onClickRefresh() {
      this.fetchDataForRider()
      this.deselectAll()
    },
    onClickPrint(id) {
      this.$refs.print_deposit_modal.openModal(id)
    },
    onClickRef(order) {
      this.$router.push({
        name: 'rider-deposit-orders',
        params: {
          id: order,
        },
      })
    },
    onClickSelectAllCheckbox() {
      if (this.selectAllCheckbox) {
        // If the "Select All" checkbox is checked, select all waybill numbers.
        this.depositSelected = this.items.map(n => n.id)
      } else {
        this.depositSelected = []
      }
    },
  },
}
</script>
<style lang="scss">
@import '../../@core/scss/vue/libs/vue-select.scss';
.add-margin-bottom {
    margin-bottom: 20px;
}
@media (max-width: 767px) {
  .add-margin-bottom {
    width: 100%;
  }
  .pagination-text {
    font-size: 0.75rem;
  }
}
</style>
